import React from 'react';

const Offer = () => {
  return (
    <section id='offer'>
      <div className='container tc'>
        <div className='s-48'></div>
        <h3 className='title-sub'>Course Program</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          Choose your career path from three specialized tracks:
        </h4>
        <div className='s-48'></div>
        <div className='row'>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>🤖</p>
              <h3 className='title-card'>AI</h3>
              <ul className='c-list'>
                <li>AI & Machine Learning</li>
                <li>Data Science & Analytics</li>
                <li>Prompt Engineering</li>
              </ul>
              <a href='#cta' className='button pink'>
                Learn More
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>💻</p>
              <h3 className='title-card'>Tech</h3>
              <ul className='c-list'>
                <li>Software Engineering</li>
                <li>DevOps & Cloud Computing</li>
                <li>Cybersecurity & Ethical Hacking</li>
              </ul>
              <a href='#cta' className='button pink'>
                Learn More
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>🎨</p>
              <h3 className='title-card'>Non-tech</h3>
              <ul className='c-list'>
                <li>UI/UX Design</li>
                <li>Graphic & Web Design</li>
                <li>Digital & Social Media Marketing</li>
              </ul>
              <a href='#cta' className='button pink'>
                Learn More
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='s-48'></div>
        </div>
      </div>
    </section>
  );
};

export { Offer };
